module.exports = __webpack_public_path__ + "img/logo.b9b9cba8.png";